import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findWorkOrderList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/workOrder/workOrderList?` + params,
        method: 'GET'
    })
}
export const findCategoryAll = () => {
    /* return request({
        url: `${baseUrl}/joins-work/v1/category`,
        method: 'GET'
    }) */
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/findAll`,
        method: 'GET'
    })
}
export const findItemsByCategory = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v1/item/items/${id}`,
        method: 'GET'
    })
}

export const findUsersByUserType = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsers?` + params,
        method: 'GET'
    })
}
export const findUsersByUserTypeAll = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUsersAll?` + params,
        method: 'GET'
    })
}
export const serviceListing = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrder/serviceListing/${id}`,
        method: 'GET'
    })
}
export const insertWorkOrderMerchants = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/insertWorkOrderMerchants`,
        method: 'POST',
        data: data
    })
}
export const userPass = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/userPass`,
        method: 'PUT',
        data: data
    })
}
export const userRefused = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/userRefused`,
        method: 'PUT',
        data: data
    })
}
export const immediatePay = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/immediatePay`,
        method: 'PUT',
        data: data
    })
}
export const balancePay = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/balancePay`,
        method: 'PUT',
        data: data
    })
}


export const evaluation = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/evaluation`,
        method: 'PUT',
        data: data
    })
}
export const updateWorkOrderMerchants = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/updateWorkOrderMerchants`,
        method: 'PUT',
        data: data
    })
};
export const statusSearch = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-work/v1/workOrder/workOrderList?` + params,
        method: 'GET'
    })
};

export const cancelWorkOrder = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrder/cancelWorkOrder/${id}`,
        method: 'GET'
    })
};

export const downloadExcelWorkOrder = (params) => {
    params = parseParam(params)
    let url = `${baseUrl}` + "/joins-work/v1/workOrderAudit/downloadExcelWorkOrder?" + params
    window.open(url);
}

export const downloadExcelStockMonitor = (params) => {
    params = parseParam(params)
    let url = `${baseUrl}` + "/joins-invoice-system/v1/credit/downloadExcelCredit?" + params
    window.open(url);
}
